import clsx from "clsx";
import React, { CSSProperties } from "react";
import { CollectionNode } from "types";
import { xolaUri } from "../../../../api/xolaUri";
import { getXolaImageSize, Image, ImageSizes } from "../../../Common/ProductImage";
import { getPlaceholderImageUrl } from "@/models/Product";

export interface CollectionImageProps {
    collection: CollectionNode;
    size?: keyof typeof ImageSizes;
    className?: string;
    classNames?: { image?: string; container?: string };
    style?: CSSProperties;
}

export const CollectionImage = ({
    collection,
    size = "medium",
    className,
    classNames,
    ...rest
}: CollectionImageProps) => {
    const imageClassName = clsx(
        "border object-fill rounded",
        "!border-gray-light",
        ImageSizes[size],
        classNames?.image ?? "",
    );

    return (
        <div
            className={clsx(
                "ui-collection-image mr-3 flex-shrink-0 rounded border-[3px] border-transparent",
                className,
            )}
            {...rest}
        >
            <CollectionImageElement className={imageClassName} collection={collection} size={size} />
        </div>
    );
};

interface CollectionImageElementProps {
    collection: CollectionNode;
    className: string;
    size?: keyof typeof ImageSizes;
}

const CollectionImageElement = ({ collection, size, className }: CollectionImageElementProps) => {
    const xolaSize = getXolaImageSize(size);

    const imageSource = collection.photo?.id
        ? `${xolaUri}/api/collectionNodes/${collection.id}/photo?size=${xolaSize}&photoId=${collection.photo.id}    `
        : getPlaceholderImageUrl(size);

    return (
        <Image
            data-collection-id={collection?.id}
            src={imageSource}
            alt={collection?.name?.trim() ?? "Collection Image"}
            className={className}
        />
    );
};
